import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";

import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm/CbmImpl";
import { Action } from "~/modules/actions/Action";


















export class EndConferenceForAll implements Action<Promise<Task>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        logger.debug(`endConferenceForAll invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "endConferenceForAll: Worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");
        if (!reservation) {
            const errorMsg = "endConferenceForAll: Reservation not found";
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.EndConferenceForAllCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
        try {
            const { task } = await cbm.endConference(reservation);
            sendTrackingEvent(EVENTS.EndConferenceForAllCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return task;
        } catch (error) {
            const errorMsg = `endConferenceForAll: Could not end conference with task sid ${reservation.task.sid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.UnholdParticipantCompleted, analytics, worker, { error: errorMsg });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
    }
}
